
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/currencies",
      function () {
        return require("private-next-pages/currencies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/currencies"])
      });
    }
  